// extracted by mini-css-extract-plugin
export default {"homePage":"AnimationGeneration_homePage__D+WQT","section":"AnimationGeneration_section__KIdvL","fadeIn":"AnimationGeneration_fadeIn__KKa9-"};